<template>
  <generic-modal :title="$t('product information')" ref="generic_modal">
    <div>
      <pre>{{ product }}</pre>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "RestaurantProductModal",
  components: { GenericModal },
  data() {
    return {
      product: {},
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/restaurant/product", { uuid: uuid })
        .then((element) => {
          v.product = element;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.product = {};
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
